module.exports = __webpack_public_path__ + "static/media/liquidity.f29586d4.svg";